import {ReportData} from "../../../reports/report.data";
import {collection, field} from "@fedeltapointofsale/data-client";
import {InventoryReportSelectionData} from "../../inventory/controls/inventory-report-selection-control.component";

export class StockInTransitReportData extends ReportData<StockInTransitReportData> {
    @field stockTransferGroupBy: string = "Destination";

    @collection(InventoryReportSelectionData) inventories: InventoryReportSelectionData[];
}
